/**
 * Shared business journey for the default four-card CTA popup.
 *
 * CtaPopup remains presentation-only. This layer owns the default actions:
 * meal rating, referral, preferences, and Trustpilot.
 *
 * Usage:
 *   CtaPopupJourney.openDefaultCta({
 *     source: 'Save My Meals',
 *     subscriptionId: '123',
 *     context: { chargeDate: '2026-08-01' },
 *     onDismiss: function () {}
 *   });
 */
(function () {
  var REFERRAL_URL = '/account?view=referral';
  var PREFERENCES_URL = '/account?view=preferences';
  var TRUSTPILOT_URL = 'https://uk.trustpilot.com/review/www.fuelhub.co.uk';

  function openDefaultCta(options) {
    var opts = options || {};
    var source = opts.source || 'CtaPopupJourney';

    if (!window.CtaPopup) {
      console.warn('[' + source + '] CtaPopup is not available');
      return false;
    }

    var suppressDefaultDismiss = false;

    function removeDefaultDismissListener() {
      document.removeEventListener('cta-popup:hide', handleDefaultDismiss);
    }

    function handleDefaultDismiss() {
      removeDefaultDismissListener();
      if (!suppressDefaultDismiss && typeof opts.onDismiss === 'function') {
        opts.onDismiss();
      }
    }

    function navigate(url, card) {
      removeDefaultDismissListener();
      if (typeof opts.beforeNavigate === 'function') {
        opts.beforeNavigate(url, card);
      }
      window.location.href = url;
    }

    function getPreferencesUrl() {
      if (opts.preferencesUrl) return opts.preferencesUrl;
      if (opts.subscriptionId) {
        return PREFERENCES_URL + '&id=' + opts.subscriptionId + '&prefs=true';
      }
      return PREFERENCES_URL;
    }

    function openMealRating() {
      if (
        !window.MealRatingJourney ||
        typeof window.MealRatingJourney.openLastOrderRating !== 'function'
      ) {
        console.warn(
          '[' + source + '] MealRatingJourney.openLastOrderRating is not available; keeping CTA popup open'
        );
        return;
      }

      var mealRatingOptions = opts.mealRating || {};
      var opened = window.MealRatingJourney.openLastOrderRating({
        source: mealRatingOptions.source || source,
        context: mealRatingOptions.context || opts.context,
        beforeFollowUp: function (payload) {
          if (typeof mealRatingOptions.beforeFollowUp === 'function') {
            mealRatingOptions.beforeFollowUp(payload);
          }

          if (typeof opts.onDismiss === 'function') {
            document.addEventListener('cta-popup:hide', opts.onDismiss, { once: true });
          }
        },
        onClose: function () {
          if (typeof mealRatingOptions.onClose === 'function') {
            mealRatingOptions.onClose();
            return;
          }

          if (typeof opts.onDismiss === 'function') {
            opts.onDismiss();
          }
        }
      });

      if (!opened) {
        console.warn('[' + source + '] no last rateable order; keeping CTA popup open');
        return;
      }

      // Hiding this CTA is a transition to Meal Rating, not a user dismissal.
      suppressDefaultDismiss = true;
      window.CtaPopup.hide();
    }

    function handleDefaultCardClick(card) {
      if (!card) return;

      console.log('[' + source + '] default CTA card clicked', {
        id: card.id,
        context: opts.context || null
      });

      switch (card.id) {
        case 'meal-rating':
          openMealRating();
          break;
        case 'refer-a-friend':
          navigate(REFERRAL_URL, card);
          break;
        case 'preferences':
          navigate(getPreferencesUrl(), card);
          break;
        case 'leave-review':
          window.open(TRUSTPILOT_URL, '_blank', 'noopener,noreferrer');
          break;
        default:
          console.log('[' + source + '] unhandled default CTA card', card.id);
      }
    }

    document.addEventListener('cta-popup:hide', handleDefaultDismiss);

    var popupOptions = {
      onCardClick: handleDefaultCardClick
    };
    if (opts.title !== undefined) popupOptions.title = opts.title;
    if (opts.subtitle !== undefined) popupOptions.subtitle = opts.subtitle;
    if (opts.cards !== undefined) popupOptions.cards = opts.cards;

    console.log('[' + source + '] opening default CTA', opts.context || {});
    window.CtaPopup.show(popupOptions);
    return true;
  }

  window.CtaPopupJourney = {
    openDefaultCta: openDefaultCta
  };

  // Account nav: CTA pop up (thin entry point — all card actions live in openDefaultCta)
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-open-cta-popup]');
    if (!link) return;

    event.preventDefault();
    openDefaultCta({ source: 'Account nav CTA' });
  });
})();
